import * as Redux from 'redux'
import * as ReduxObservable from 'redux-observable'
import * as App from '../../app'
import * as Form from '../../components/form'
import * as IsActive from '../../components/is_active'
import * as Request from '../../request'
import { ApplicationState } from '../../rootReducer'
import * as Router from '../../router'
import * as Actions from './actions'
import * as Constants from './constants'
import * as SendEmailModal from './send-email-modal/epic'

const updateUrl: ReduxObservable.Epic<any, any> = (action$) =>
  action$.ofType(Constants.UPDATE_SELECTED_DATE)
    .mergeMap((action) => [App.updateUrlParams({selectedDate: action.date}),
                           Actions.dateChange(action.date)])

const updateGrid: ReduxObservable.Epic<any, any> = (
  action$: ReduxObservable.ActionsObservable<any>,
  store: Redux.Store<ApplicationState>) =>
  action$.ofType(Constants.UPDATE_SELECTED_DATE)
  .map(store.getState)
  .mergeMap((action) => [
    Actions.fetchLeadPosts(store.getState().app.selectedCommunity, dateSelector(store.getState())),
    Actions.fetchLeadText(store.getState().app.selectedCommunity, dateSelector(store.getState())),
    Actions.fetchPromotions(store.getState().app.selectedCommunity, dateSelector(store.getState()))])

const  dateSelector: any = (state: ApplicationState) => state.contentCalendar.data.selectedDate

type OnEnter = ReduxObservable.Epic<Redux.Action, any>
const onEnter: OnEnter = (
  action$: ReduxObservable.ActionsObservable<any>,
  store: Redux.Store<ApplicationState>,
  {history}: App.Dependencies) =>
  action$.ofType(Router.ON_ENTER)
  .filter(() => history.location.pathname === Constants.CALENDAR_SERVER_RESOURCE)
  .map(store.getState)
  .mergeMap((action, state) => [
    App.updateUrlParams({selectedDate: dateSelector(store.getState())}),
    Actions.fetchLeadPosts(store.getState().app.selectedCommunity, dateSelector(store.getState())),
    Actions.fetchLeadText(store.getState().app.selectedCommunity, dateSelector(store.getState())),
    Actions.fetchPromotions(store.getState().app.selectedCommunity, dateSelector(store.getState()))])

type OnAddition = ReduxObservable.Epic<Redux.Action, any>
const onAddition: OnAddition = (
  action$: ReduxObservable.ActionsObservable<any>,
  store: Redux.Store<ApplicationState>,
  {history}: App.Dependencies) =>
  action$.ofType
  (Request.successConstant(Constants.ADD_LEAD_POST),
   Request.successConstant(Constants.PUT_LEAD_TEXT),
   Request.successConstant(Constants.POST_LEAD_TEXT),
   Request.successConstant(Constants.ADD_PROMOTION),
   Request.successConstant(Constants.EDIT_PROMOTION))
  .filter(() => history.location.pathname === Constants.CALENDAR_SERVER_RESOURCE)
  .map(store.getState)
  .mergeMap((action, state) => [
    App.updateUrlParams({selectedDate: dateSelector(store.getState())}),
    Actions.fetchLeadPosts(store.getState().app.selectedCommunity, dateSelector(store.getState())),
    Actions.fetchLeadText(store.getState().app.selectedCommunity, dateSelector(store.getState())),
    Actions.fetchPromotions(store.getState().app.selectedCommunity, dateSelector(store.getState())),
  ])

type OnPush = ReduxObservable.Epic<Redux.Action, any>
const onPush: OnPush = (
  action$: ReduxObservable.ActionsObservable<any>,
  store: Redux.Store<ApplicationState>,
  {history}: App.Dependencies) =>
  action$.ofType(Router.LOCATION_CHANGE)
  .filter(() => history.location.pathname === Constants.CALENDAR_SERVER_RESOURCE)
  .map(store.getState)
  .mergeMap((action, state) => [App.updateUrlParams({selectedDate: dateSelector(store.getState())})])

type sortOnEnter = ReduxObservable.Epic<Redux.Action, any>
const sortOnEnter: sortOnEnter = (
  action$,
  store: Redux.Store<ApplicationState>,
  {history}: App.Dependencies) =>
  action$.ofType(Request.successConstant(Constants.FETCH_CALENDAR_LEAD_TEXT),
  Request.successConstant(Constants.FETCH_CALENDAR_POSTS),
  Request.successConstant(Constants.FETCH_CALENDAR_PROMOTIONS))
  .filter(() => history.location.pathname === Constants.CALENDAR_SERVER_RESOURCE)
  .map(Actions.calendarEnterSort)

const onSuccessfullReorder = (
  action$: ReduxObservable.ActionsObservable<any>,
  store: Redux.Store<ApplicationState>) => action$.ofType(Request.successConstant(Constants.SAVE_REORDERED_LEAD_POST))
  .mergeMap((action, state) => [
    Actions.fetchLeadPosts(store.getState().app.selectedCommunity, dateSelector(store.getState())),
    Actions.fetchLeadText(store.getState().app.selectedCommunity, dateSelector(store.getState())),
    Actions.fetchPromotions(store.getState().app.selectedCommunity, dateSelector(store.getState())),
  ])

export const epic = ReduxObservable.combineEpics(
  updateUrl,
  SendEmailModal.epic,
  onEnter,
  onPush,
  onAddition,
  updateGrid,
  onSuccessfullReorder,
  sortOnEnter,
  IsActive.createStatusUpdateEpic(Constants.UPDATE_CALENDAR, Actions.update),
  Form.validateForm('leadPosts', Actions.FormConstants, Actions.FormActions, Constants.FormValidators),
  Form.validateFormOnOpen('leadPosts', Actions.FormConstants, Actions.FormActions, Constants.FormValidators),
)



// WEBPACK FOOTER //
// ./src/pages/content-calendar/epic.ts